'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article9() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задача
					</Typography>
					<Typography variant='p1'>
						Создать интуитивно понятный и информативный сайт для интернет-провайдера. Чтобы пользователи могли
						быстро и удобно ознакомиться с тарифами, оставить заявку на подключение интернета и телевидения или
						оплатить услуги.
					</Typography>

					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-1.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Что сделали
					</Typography>
					<Typography variant='h3' className={styles.article__headline}>
						Собрали понятную и удобную главную страницу
					</Typography>
					<Typography variant='p1'>
						На главной странице расположили карточки с услугами, условия тарифов — большинство посетителей
						приходят на сайты провайдеров за этой информацией. Также сделали слайдер с баннерами для актуальных
						акций и спецпредложений и блок с новостями.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-2.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='h3' className={styles.article__headline}>
						Ввели цветовое кодирование тарифов
					</Typography>
					<Typography variant='p1'>
						Мы разработали возможность изменять цвет карточки и добавлять к ней лейбл «Популярный», чтобы клиент
						мог выделять тарифы, которые наиболее актуальны для продажи. Например, сейчас на сайте, чем быстрее
						тариф, тем ярче у него подложка сверху.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-3.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='h3' className={styles.article__headline}>
						Разработали конструктор тарифов
					</Typography>
					<Typography variant='p1'>
						Клиент хотел, чтобы у пользователей была возможность собрать собственный тариф из необходимых услуг,
						отталкиваясь от своих потребностей. Например, включить в свой тариф безлимитный интернет на скорости
						130 Мбит/сек., 44 телеканала и IP-видеонаблюдение или безлимитный интернет на скорости 200 Мбит/сек и
						2 футбольных телеканала.
					</Typography>
					<Typography variant='p1'>
						Мы разработали специальный конструктор тарифов, который настраивается из административной панели со
						стороны администратора сайта. Можно редактировать категории услуг, категории тарифов, карточки
						тарифов. В карточке тарифов можно отредактировать любой текст, выбрать цвет карточки и присвоить лейбл
						«Популярный».
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-4.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Добавили «новости» и «акции» в меню
					</Typography>
					<Typography variant='p1'>
						На старом сайте было сложно найти страницу новостей, поэтому на новом мы сделали «новости» и «акции»
						отдельными пунктами в меню.
					</Typography>
					<Typography variant='p1'>
						Внутри новостей и акций расположили блок с последними постами. Так пользователи увидят больше важной
						информации.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-5.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/9-6.png').default,
								placeholder: 'blur'
							}
						]}
						row
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Добавили блок с часто задаваемыми вопросами
					</Typography>
					<Typography variant='p1'>
						Узнали у клиента, с какими вопросами чаще всего обращаются в техподдержку, собрали ответы и
						сформировали новый блок с часто задаваемыми вопросами.
					</Typography>
					<Typography variant='p1'>
						Пользователям с типичными вопросами теперь не нужно обращаться в техподдержку и подолгу ждать ответа
						оператора. Вследствие этого уменьшилась нагрузка на специалистов колл-центра.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-7.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Переработали справочник абонента
					</Typography>
					<Typography variant='p1'>
						В старом справочнике не было структуры и разделов, информация про услуги интернета, телевидения,
						IP-видеонаблюдения находилась в одном месте. Пользователям было неудобно им пользоваться. Например,
						чтобы найти информацию о том, как переоформить договор на другого человека, нужно было пролистать
						несколько десятков записей.
					</Typography>
					<Typography variant='p1'>
						Поэтому в новом дизайне справочника мы добавили возможность создавать категории для статей. Сейчас
						вопросы по услугам распределены по отдельным блокам.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-8.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Вывели кнопку оплаты на видное место
					</Typography>
					<Typography variant='p1'>
						Действующие клиенты Тулун-телеком чаще всего заходят на сайт, чтобы просто оплатить услуги. Поэтому мы
						расположили кнопку «Эксперсс-оплата» в шапке сайта. Так кнопка всегда находится на виду, это помогает
						пользователям быстрее сориентироваться и оплатить услуги.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-9.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Адаптировали сайт под мобильные устройства
					</Typography>
					<Typography variant='p1'>
						У старого сайта не было версий под мобильные телефоны и планшеты, несмотря на то, что в России около
						80% всего трафика приходится на мобильные устройства (по данным аналитиков SlickJump).
					</Typography>
					<Typography variant='p1'>
						Сейчас пользователи могут удобно пользоваться сайтом провайдера с любых устройств.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-10.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Увеличили скорость загрузки сайта
					</Typography>
					<Typography variant='p1'>
						Улучшили показатели скорости загрузки сайта с мобильных устройств в 2,1 раза, а с компьютеров и
						ноутбуков — в 1,5 раза.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-11.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Что ещё сделали
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/9-12.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/9-13.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/9-14.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/9-15.png').default,
								placeholder: 'blur'
							}
						]}
					/>
				</section>

				<section className={`${styles.article__section} ${styles.article__section__results}`}>
					<Typography variant='h2' className={styles.article__headline}>
						Результаты работы
					</Typography>
					<div className={styles.article__results}>
						<section className={styles.article__results__section}>
							<Typography variant='h3'>10459</Typography>
							<Typography variant='h5' color='description'>
								посетителей
							</Typography>
						</section>
						<section className={styles.article__results__section}>
							<Typography variant='h3'>5 мин</Typography>
							<Typography variant='h5' color='description'>
								за посещение в среднем
							</Typography>
						</section>
						<section className={styles.article__results__section}>
							<Typography variant='h3'>5 стр</Typography>
							<Typography variant='h5' color='description'>
								за посещение в среднем
							</Typography>
						</section>
					</div>
				</section>
				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
